import { OMNIBUS_ORDER_STATUS, ORDER_TYPE } from 'const/trade'

/**
 * 格式化订单服务端数据到本地数据格式，保证数据结构一致性
 *
 * @param { object } order - 服务端订单数据
 * @param { boolean } isIb - 是否是 ib 账户
 */
export default function getFixedOrderDetail(order, isIb) {
  if (Array.isArray(order)) {
    return order.map(o => getFixedOrderDetail(o, isIb))
  }
  // 避免重复数据转换
  if (order.__order__) return order

  // 精确度调整
  const isLMT = [ORDER_TYPE.LMT, ORDER_TYPE.STP_LMT].includes(order.orderType)
  const isSTP = [ORDER_TYPE.STP, ORDER_TYPE.STP_LMT].includes(order.orderType)
  const isTRAIL = order.orderType === ORDER_TYPE.TRAIL
  if (isIb) {
    const { auxPrice, ...data } = order
    if (isLMT) {
      data.stpPrice = auxPrice
    }
    if (isSTP) {
      data.stpPrice = auxPrice
    }
    // 跟踪单区分百分比和数值
    if (isTRAIL) {
      if (order.trailingPercent) {
        data.orderType = ORDER_TYPE.TRAIL_1
      } else {
        data.orderType = ORDER_TYPE.TRAIL_2
        data.trailingPrice = auxPrice
      }
    }
    data.__order__ = true
    return data
  }
  const { onlyRth, id, idStr, price, ...data } = order
  data.orderId = idStr || id
  data.outsideRth = !onlyRth
  if (isLMT) {
    data.limitPrice = price
  }
  if (isSTP) {
    data.stpPrice = data.stopPrice
  }
  if (data.filledQuantity) {
    data.filledQuantity =
      data.filledQuantity / Math.pow(10, data.filledQuantityScale || 0)
  }
  if (data.totalQuantity) {
    data.totalQuantity =
      data.totalQuantity / Math.pow(10, data.totalQuantityScale || 0)
  }
  if (
    [OMNIBUS_ORDER_STATUS.NEW, OMNIBUS_ORDER_STATUS.PENDING_NEW].includes(
      data.status
    )
  ) {
    data.latestTime = data.updatedAt * 1000
  } else {
    data.latestTime = data.statusUpdatedAt * 1000
  }
  if (data.createdAt) {
    data.openTime = data.createdAt * 1000
  }
  data.__order__ = true
  return data
}
